import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";

const UKCommunicationRecordReportingComponent = () => {
  const navigate = useNavigate();
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [filesData, setFilesData] = useState({});
  const [columnData, setColumnData] = useState([]);
  const [fileDownload, setFileDownload] = useState("");
  const [loading, setLoading] = useState(false);
  const clientData = JSON.parse(localStorage.getItem("clientDetails"));
  const side = "Output";

  const getStoredFiles = () => {};

  const handleFileDownload = (obj) => {
    setFileDownload(obj);
    setShowDownloadModal(!showDownloadModal);
  };

  useEffect(() => {
    getStoredFiles();
  }, []);
  return (
    // <>
    //   {!loading ? (
    //     <div>
    //       <div className="dashboard_header_fs">
    //         <div className="dash_btn_fs">
    //           <button
    //             className="dash_btn_fs"
    //             type="button"
    //             onClick={() => getStoredFiles()}
    //           >
    //             Choose File
    //           </button>
    //         </div>
    //         <div className="dash_btn_fs">
    //           <button
    //             className="dash_btn_fs"
    //             type="button"
    //             onClick={() => getStoredFiles()}
    //           >
    //             Refresh
    //           </button>
    //         </div>
    //       </div>
    //       <div className="dashboard_inner_fs">
    //         <div className="rx_table_wrapper table-responsive padding-fix">
    //           <table className="file_storage_table text-center">
    //             <thead>
    //               {/* <tr className="border_bt_none">
    //                 {columnData && columnData.length > 0 ? (
    //                   columnData.map((obj, index) => <th key={index}>{obj}</th>)
    //                 ) : (
    //                   <></>
    //                 )}
    //               </tr> */}
    //               <tr>
    //                 <th key={1}>CN</th>
    //                 <th key={2}>FileName</th>
    //                 <th key={3}>Type</th>
    //                 <th key={4}>Date</th>
    //                 <th key={5}>Download</th>
    //               </tr>
    //             </thead>
    //             <tbody>
    //               {/* {filesData && filesData.length > 0 ? (
    //                 filesData.map((obj, index) => (
    //                   <tr key={index}>
    //                     <td>{obj.SN}</td>
    //                     <td>{obj.FileName}</td>
    //                     <td>{obj.Type}</td>
    //                     <td>{obj.Date}</td>
    //                     <td>{obj.Time}</td>
    //                     <td onClick={() => handleFileDownload(obj.Download)}>
    //                       <FaFileDownload />
    //                     </td>
    //                   </tr>
    //                 ))
    //               ) : ( */}

    //               <tr key={1}>
    //                 {/* <td>{obj.SN}</td>
    //                   <td>{obj.FileName}</td>
    //                   <td>{obj.Type}</td>
    //                   <td>{obj.Date}</td>
    //                   <td>{obj.Time}</td>
    //                   <td onClick={() => handleFileDownload(obj.Download)}>
    //                     <FaFileDownload />
    //                   </td> */}
    //                 <td>1</td>
    //                 <td>FIRM_BarclaysIND_AIFMD_AIF_Q1_20240523_01.xml</td>
    //                 <td>xml</td>
    //                 <td>2024-05-23</td>
    //                 <td>16:17:49</td>
    //                 {/* <td onClick={() => handleFileDownload(obj.Download)}>
    //                   <FaFileDownload />
    //                 </td> */}
    //                 <FaFileDownload />
    //               </tr>
    //             </tbody>
    //           </table>
    //         </div>
    //         {showDownloadModal && (
    //           <FileDownloadModal
    //             show={showDownloadModal}
    //             onHide={() => setShowDownloadModal(false)}
    //             onDownload={fileDownload}
    //             downloadText="Do you want to download the file?"
    //             showDownloadModal
    //           />
    //         )}
    //       </div>
    //     </div>
    //   ) : (
    //     <div></div>
    //   )}
    // </>
    <>
      <main className="middle_section dashboard_middle">
        <div className="container">
          <NotSubscribedMessageComponent />
        </div>
      </main>
    </>
  );
};

export default UKCommunicationRecordReportingComponent;
